import { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { Element } from '../../../common/html/element'
import { LayoutPanel } from '../../common/html/LayoutPanel'
import { ChartContent } from './components/ChartContent'
import { Header } from './components/Header'
import { getLoadingCreditRisk, selectActiveVSIC } from './store/slice'
import { getRiskDistribution, getVSIC } from './store/thunk'

export const CreditRisk = () => {
  const dispatch = useDispatch()

  const [isCallApi, setCallApi] = useState(false)

  const locale = useSelector((state) => state.i18n.locale)
  const loadingVSIC = useSelector(getLoadingCreditRisk('getVSIC'))
  const loadingRiskDistribution = useSelector(
    getLoadingCreditRisk('riskDistribution'),
  )
  const vsicActive = useSelector(selectActiveVSIC)

  useEffect(() => {
    dispatch(getVSIC())
  }, [locale])

  useEffect(() => {
    dispatch(
      getRiskDistribution({
        VSICId: vsicActive?.id,
      }),
    )
  }, [locale, isCallApi])

  return (
    <LayoutPanel
      loading={loadingVSIC || loadingRiskDistribution}
      style={{ height: '100%' }}
    >
      <div className="flexColumn h100 w100">
        {!loadingVSIC && <Header setCallApi={setCallApi} />}
        <div className="flex1 w100">
          {loadingVSIC || loadingRiskDistribution ? <> </> : <ChartContent />}
        </div>
        <Element style={{ fontStyle: 'italic' }}>
          <Element elementName="span" style={{ color: '#E0505B' }}>
            *
          </Element>
          <Translate value="dashboard.creditRisk.text_legend" />
        </Element>
      </div>
    </LayoutPanel>
  )
}
